
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import _cookie from "../../../assets/js/cookie"
import _com from "../../../assets/js/common"
import _intercept from "@/assets/js/intercept";
import jsonp from "../../../assets/js/http";
import unJsonp from '../../../assets/js/http';
import fetch from "@/assets/js/fetch";

@Component
export default class topModular extends Vue {
    // @Prop() private roomData!: any;
    // @Prop() private browser!: any;
    // @Prop() private source!: string;
    @Prop() private followData: any;

    api: any = {
        // getdebutBanner: `https://ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/common-recommend-cdn/v2/recommend/indexFeaturedGet/GetdebutBanner/0/live_event_recommend`,
        getPeopleCountApi: process.env.VUE_APP_URI_CDNDOMAIN + '/live/api/out/room/count/', //获取直播间观众人数
        getAttentionStatus: `https://pub${this.domain}/live/user/follow`, // 获取关注状态
        attention: `https://pub${this.domain}/live/user/follow/changeUserFollowCallable`, // 关注或取消关注

        floation: `https://ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/common-recommend-cdn/itemRecommend/sectionList/getFloation/ule_broadcast_floaticon/0`,
        exitJump: `https://ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/common-recommend-cdn/itemRecommend/sectionList/getExitjump/ule_broadcast_exit_jump/0`,

        getLike: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/room/static/like", //获取点赞数
        isNewCus: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/room/static/like", //判断新用户
        broadcastShare: "//ustatic" + process.env.VUE_APP_URI_ULECDNDOMAIN + "/common-recommend-cdn/v2/recommend/dwRecommond/jsonp22/2002/0/list/ule_broadcast_share.html", // 查分享文案
        posterInfo: "https://pub" + process.env.VUE_APP_URI_DOMAIN + "/live/tv/poster/",//获取海报信息
        shareInfo: "https://pub" + process.env.VUE_APP_URI_DOMAIN + "/live/tv/share/",//获取分享信息
        liveExitRecommend: "https://m" + process.env.VUE_APP_URI_DOMAIN + "/bigdata-api/live/liveExitRecommend",//退出直播间推荐另一个直播间


        getYshUserInfo: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/ysh/getYshUserInfo",// 查询是否注册邮生活
        registerYsh: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/ysh/registerYsh",// 快速注册邮生活
        userApply: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/ysh/userApply",// 邮生活抽奖报名参与
        winResult: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/ysh/winResult",// 邮生活中奖结果
        isuserApply: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/ysh/isuserApply",// 邮生活中奖记录
        winRecord: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/ysh/winRecord",// 邮生活中奖记录

        getToYshInfo: 'https://service' + process.env.VUE_APP_URI_DOMAIN + '/appuser/userysh/getToYshInfo',  // 获取跳转到邮生活小程序用户信息
        couponPrizeDetail: 'https://service' + process.env.VUE_APP_URI_DOMAIN + '/applive/ysh/couponPrizeDetail',    // 邮生活查券
        ysh_text: "//ustatic" + process.env.VUE_APP_URI_ULECDNDOMAIN + "/common-recommend-cdn/v2/recommend/indexFeaturedGet/live_room_ysh_event/0/live_room_ysh_event" // 活动规则
    }
    stagesApi: any = {  // 分期商城
        getYshUserInfo: 'https://service' + process.env.VUE_APP_URI_DOMAIN + '/applive/psbcshop/isUser/',// 分期商城-查询用户是否注册
        winRecord: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/psbcshop/winRecord/",// 邮生活中奖记录
        registerYsh: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/psbcshop/register/",// 分期商城-用户注册
        userApply: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/psbcshop/userApply/",// 分期商城-用户参与抽奖
        winResult: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/psbcshop/winResult/",// 分期商城-查询用户中奖结果
        isuserApply: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/psbcshop/isUserApply/",// 邮生活中奖记录
        // 分期商城-查询用户是否参与抽奖
    }
    isNewPeople: Boolean = false   // 是否是新人
    floationData: any = { customAttribute: {} };
    browser = _com.browser();
    isWx = _com.isWx()
    isBtnShow: boolean = false//是否显示邮生活跳转按钮  否则展示小程序跳转按钮
    posterImgUrl: any = ""//海报地址
    wxHtml: string = ''
    toYsh: string = ''
    toYshDD: string = ''
    textS: any = (<any>window).location.href
    look: any = false
    selected: any = 1
    isShowBottomLive: any = false
    isShowAttentionPop: boolean = false // 显示关注弹框
    isShowOtherLive: boolean = false // 显示其他直播间
    attentionStatus: number = 0 // 关注状态
    roomId: string = "" // 房间id
    cutdownTime: number = 5000 // 倒计时
    timer: any = null
    newUser: any = '9999' // 是否是新用户
    show: Boolean = false
    isMinuteOut: boolean = true // 手动推送一分钟一次
    lotteryShow: any = ''
    userId: any
    selectedLive: any = []
    countDown: any = 1000
    isLottery: any
    second: any = 3
    lotteryList: any = []
    lotteryMouth: Boolean = false
    lotteryImg: any
    YhsLinkData: any
    lotteryId: any
    winningBullet: Boolean = false
    oneLottery: boolean = true
    lotteryCentre: Boolean = true
    countDownTime: any
    yshRules: any
    placeAnOrder: any = []
    exitJumpLink: any
    isShowNavBar: boolean = true
    isWinningRecord: any = false
    stagesEnvironment: any = false  // 是否来源分期
    environment: any
    isRegisterStages: any   //是否注册分期商城 0已注册 1未注册
    environmentMp: any = false
    drainageTitle: any = '浏览更多直播'
    drainageTolink: any
    timeOut: any
    get people() {//房间观众数
        return this.$store.getters["timing/getPeople"];
    }
    get likeNum() {
        let num: number = this.$store.getters["timing/getLike"];
        return num < 10000 ? num : Math.round(num / 10000).toFixed(1) + 'w'

    }
    get roomData() {//房间数据
        sessionStorage.setItem('roomData', JSON.stringify(this.$store.getters["getRoomDetail/getRoomDetail"]))
        return this.$store.getters["getRoomDetail/getRoomDetail"];
    }
    get yshLottery() {
        return this.$store.getters["refresh/getYshLottery"];
    }
    get clearScreen() {
        return this.$store.getters["environment/getClearScreen"];
    }

    get isShare() {
        return this.$store.getters["environment/getIsShare"];
    }
    get follow() {
        return this.$store.getters["refresh/getFollow"];
    }
    get hotGoodLists() {
        return this.$store.getters["refresh/getHotGoodList"]
    }
    // 监测手动推送卡片
    @Watch('follow')
    watchFollow(val: any) {
        // 手动推送发起，未关注用户一分钟内只弹出一次
        if (val.follow && this.isMinuteOut && !this.attentionStatus) {
            this.showAttention()
            this.isMinuteOut = false
            clearTimeout(this.timer)

            setTimeout(() => {
                this.isMinuteOut = true
            }, 1000 * 60)
        }
    }
    @Watch('isShare')
    watchIsShare(val: any) {
        // 监听分享
        if (val) {
            this.getPosterUrl()

            setTimeout(() => {
                this.$store.dispatch("environment/getIsShareAsync", false);
            }, 2000)
        }
    }
    @Watch('followData')
    watchFollowData(val: any) {
        this.attentionStatus = +val
    }
    @Watch('isShowBottomLive')
    watchIsShowBottomLive(val: any) {
        return false   //取消自动跳转逻辑
        if (val == true) {
            // this.$http
            //     .jsonp(this.api.getdebutBanner, {
            //         jsonp: "jsonpCallback",
            //         jsonpCallback: "GetdebutBanner",
            //     }).then((data: any) => {
            //         debugger
            //         console.log(data.data.indexInfo[0]);
            //         if (data.data.indexInfo[0] && data.data.indexInfo[0].link) {
            //             this.drainageTitle = data.data.indexInfo[0].title
            //             this.drainageTolink = data.data.indexInfo[0].link
            //         }
            //     })

            let date = new Date()
            localStorage.setItem(`storageTime-${this.roomData.id}-${this.roomData.roomNumber}`, `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${this.roomData.id}-${this.roomData.roomNumber}`)
            let dateLoc = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            localStorage.setItem('dateOff', dateLoc)

            this.timeOut = setInterval(() => {
                this.second -= 1
                if (this.second == 0) {
                    if (this.selectedLive && this.selectedLive[0] && this.selectedLive[0].liveUrl) {
                        location.href = this.selectedLive[0].liveUrl
                    } else {
                        // location.href = `https://h5${process.env.VUE_APP_URI_DOMAIN}/hd/debutBroadcastList/index.html`
                        // this.isShowBottomLive = false
                    }
                }
            }, 1000)
            // setTimeout(() => {
            //     if (this.selectedLive && this.selectedLive[0] && this.selectedLive[0].liveUrl) {
            //         location.href = this.selectedLive[0].liveUrl
            //     }
            // }, 3000000)
        }
    }
    @Watch('yshLottery')
    getYshLottery(val: any) {
        if (val) {
            this.lotteryMouth = Boolean(val['id'])
            this.lotteryId = val['id']
            if (this.lotteryMouth) {
                let end_time: any = (new Date(val.end_time.replace(/-/g, '/')))
                let timeDValue = Date.parse(end_time) - new Date().getTime()
                this.countDown = timeDValue > 0 ? timeDValue : this.lotteryMouth = false
                // if (val.prizes_status == 3 && this.oneLottery) {
                //     this.finish()
                // } else {
                //     this.oneLottery = true
                // }
            }
            this.isWinningRecord = Boolean(val.prizes_status)
            this.$emit('downData', {
                lotteryMouth: this.lotteryMouth,
                countDown: this.countDown,
                isWinningRecord: Boolean(val.prizes_status)
            })
        }
    }
    beforeDestroy() {
        clearInterval(this.timeOut)
    }
    created() {
        this.isShowNavBar = !(window.navigator.userAgent.toLowerCase().indexOf('unicom') > -1)
    }
    luckyOrdering() {
        this.$http
            .jsonp(this.api.ysh_text, {
                jsonp: "jsonpCallback",
                jsonpCallback: "live_room_ysh_event",
            }).then((data: any) => {
                if (data.body.returnCode == '0000') {
                    let datas = data.data.indexInfo[0]
                    this.$dialog.alert({
                        title: '邮生活下单礼活动规则',
                        messageAlign: 'left',
                        message: datas.show_text_luckyorder,
                    })
                    this.show = false
                }
            })
    }
    rulesApi() {
        this.$http
            .jsonp(this.api.ysh_text, {
                jsonp: "jsonpCallback",
                jsonpCallback: "live_room_ysh_event",
            }).then((data: any) => {
                if (data.body.returnCode == '0000') {
                    this.yshRules = data.data.indexInfo[0]
                    this.selected == 1
                    this.$dialog.alert({
                        title: this.selected == 1 ? '惊喜抽奖礼活动规则' : '邮生活下单礼活动规则',
                        messageAlign: 'left',
                        message: this.selected == 1 ? this.yshRules.show_text_lotterydraw : this.yshRules.show_text_luckyorder,
                    })
                    // 1
                    this.lotteryShow = ''
                }
            })
    }
    showInfo() {
         this.$emit('openShow', {
            //    roomData: this.roomData,
            })
    }
    exitJump() {
        let that = this
        jsonp(this.api.exitJump, {
            jsonp: "getExitjump",
        }).then(
            (<any>window).getExitjump = (data: any) => {
                try {
                    if (!data.ule_broadcast_exit_jump[0].link) return this.closeOperation()
                    that.exitJumpLink = data.ule_broadcast_exit_jump[0].link
                    this.isNewPeople = true
                } catch (error) {
                    this.closeOperation()
                }
            }, () => { }).catch(() => {
                this.closeOperation()
            })
    }
    agreeOn() { // 协议跳转
        window.location.href = 'https://www.ule.com/event/h5/ule/26.html'
    }
    conceal() { // 隐私跳转
        window.location.href = 'https://www.ule.com/event/h5/ule/27.html'
    }
    showJump() {
        if (this.selected == 1) return this.lotteryList.length > 0
        if (this.selected == 2) return this.placeAnOrder.length > 0
    }
    mounted() {
        let liveName = ''
        if (this.roomData.tvStatus == 0) liveName = '待开播'
        if (this.roomData.tvStatus == 1 && this.roomData.scene_type == '2') liveName = '回放'
        if (this.roomData.tvStatus == 2) liveName = '已结束'
        // 判断当前小程序环境环境
        var ua: any = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
            // (<any>window).wx.miniProgram.getEnv((res: any) => {
            //     if (res.miniprogram) {
            // alert("在小程序里")
            if (this.$route.query.from != 'yshmp') {
                this.environmentMp = true
            }
            //     } else {
            //         // alert("不在小程序")
            //     }
            // })
        } else {
            // alert("不在微信")
        }
        _com.sendSensorTrack('LiveView', this.roomData, {
            // _com.sendSensorTrack('直播间浏览', this.roomData, {
            ylw_enter_source: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
            ylw_live_id: this.roomData.id,
            ylw_live_name: this.roomData.title,
            ylw_live_type: liveName,
            roomNumber: this.$route.params.roomNumber,
            scene_number: this.roomData.scene_number,
            theme: this.roomData.theme,
            ylw_adid: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
        }, false, 'yshPoint')

        if (this.roomData.tvType == 7 || this.roomData.tvType == 8) document.title = this.roomData.theme  // 修改标题
        this.roomId = this.$route.params.id
        this.getLivePeopleCount();

        if (this.roomData.tvType == 7 || this.roomData.tvType == 8) this.stagesEnvironment = true
        if (location.href.indexOf('origin=pmcc') > -1) {
            this.environment = 'pmcc'
        } else if (location.href.indexOf('origin=yzlife') > -1) {
            this.environment = 'yzlife'
        }
        // this.getAttentionStatus();
        this.floation() //  || navigator.userAgent.indexOf('miniProgram') > -1
        if (this.browser.yshapp || this.$route.query.from == 'yshmp') {//邮生活app  或者邮生活小程序   显示点击按钮  否则显示小程序标签按钮
            this.isBtnShow = true
        }
        // setTimeout(() => {
        //     this.showAttention()
        // }, 15000)
        // // 未登录不调用关注查询接口。2022.7.18崔明需求
        // if (!_com.getMallCookie()) {
        //     return false;
        // }

        let date = new Date()
        let dateLoc = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        let dateOff = localStorage.getItem('dateOff')
        this.lookClik().then((res: any) => {
            if (dateOff != dateLoc) {
                if (this.roomData.tvStatus == 0 && this.roomData.scene_number == '' && localStorage.getItem('lookLive') == null) {
                    if (this.selectedLive.length > 0) {
                        this.isShowBottomLive = true
                        localStorage.setItem('dateOff', dateLoc)
                    }
                }
            }
        })
        this.getAttentionStatus();
    }
    // 显示关注弹框
    showAttention() {
        let cutdown: any = this.$refs.cutdown
        cutdown && cutdown.reset(); // 重置倒计时
        this.isShowAttentionPop = true
    }
    postalShare() {
        let url = new URL(location.href)
        let pageId = url.searchParams.get('pageId')
        let shId = url.searchParams.get('shId')
        let shopId = url.searchParams.get('shopId')
        let shareData = {
            title: document.title,
            msg: '原汁原味原产地',
            // url.origin + url.pathname
            // url: `https://wap.psbc.com/wxbank/h5/rousePage/#/?pageld=1994&reqPageId=1994&shId=SHID0043&shopId=63975374823424&reqUrl=${window.location.href}`,
            url: `https://wap.psbc.com/wxbank/h5/rousePage/#/?pageId=${pageId}&shId=${shId}&shopId=${shopId}&reqUrl=${url.origin + url.pathname}`,
            // url:`https://wap.psbc.com/wxbank/h5/rousePage/#/?pageId=${pageId}&shId=${shId}&shopId=${shopId}&reqUrl=${window.location.href}`,
            imgUrl: 'https://i0.ulecdn.com/i/global/ule.png',
            shareType: 'url',
            base64Img: '',
            isClipboard: '1',
            pageName: '',
            configureId: ''
        };
        (<any>window).AlipayJSBridge.call('gotoShareYouBank', shareData, function (result: any) { console.log('psbcShare', 'shareSuccess'); });
    }
    //获取海报地址
    getPosterUrl() {
        if (!_intercept()) {
            return false;
        }
        let typeObj: any = {
            'uxd': '5',
            'ule': '4',
            'usq': '3',
            'uzg': '1'
        };


        let burialPoint = {
            url: location.href,
            ule_title: window.document.title,
            button_name: '直播间-分享',
            link_url: '',
            scene_number: this.roomData.scene_number,
            roomNumber: this.$route.params.roomNumber
        }
        _com.sendSensorTrack('resourceClick', this.roomData, burialPoint, true, 'yshPoint')


        let callback = "posterInfo";
        let url = this.api.posterInfo + this.$route.params.id + "?tv_type=" + this.roomData.tvType
        jsonp(url, {
            jsonpcallback: callback,
            jsonp: 'callback',
        }).then((data: any) => {
            console.log('这里是新的海报地址', data);
            this.posterImgUrl = data || "";
            this.getShare();
        }).catch((err: any) => {
            this.getShare();
        });
    }
    tabSwitch(data: any) {
        this.selected = data
    }
    getShare() {
        // _intercept();
        //分享
        let shareUrl = location.origin + location.pathname;
        let params = {
            shareName: document.title,
            clientCallType: "H5",
            shareType: 62,
            shareLink: shareUrl,
            unionRef: this.$route.params.id
        };
        let roomNumber = this.$route.params.roomNumber;
        let shareTitle = this.roomData.theme || "直播来啦！限时特价打到骨折",
            shareContent = this.roomData.title,
            custShareImageUrl = "",
            posterImageUrl = "",
            typeObj: any = {
                'uxd': '5',
                'ule': '4',
                'usq': '3',
                'uzg': '1'
            };
        let callback = "shareInfo";
        unJsonp(this.api.shareInfo + this.$route.params.id + "?tv_type=" + this.roomData.tvType, {
            jsonpcallback: callback,
            jsonp: 'callback',
        }).then((data: any) => {
            if (data) {
                shareTitle = data.main_title || shareTitle;
                shareContent = data.sub_title || shareContent;
                custShareImageUrl = (data.url || "").replace(/http:/, "https:");
                posterImageUrl = this.posterImgUrl.replace(/http:/, "https:") || "";
            }
        }).catch((err) => {
            console.log(err);
        }).then(() => {
            let shareImageUrl = custShareImageUrl || "https:" + this.roomData.cover.replace(/^http(s)?:/, "");
            let shareObj: any = {
                shareTitle: shareTitle,
                shareContent: shareContent,
                shareImageUrl: shareImageUrl,
                shareUrl: shareUrl,
                shareUrl3: shareUrl
            };
            if (posterImageUrl) {
                shareObj.posterImageUrl = posterImageUrl
                shareObj.shareOptions = "0##1##7"
                shareObj.posterTips = "扫码进入直播间"
            } else {
                shareObj.shareOptions = "0##1"
            }
            // 补充分享埋点所需内容
            shareObj.share_content_type = '直播间'
            shareObj.share_content_name = this.roomData.title
            shareObj.share_content_id = this.roomData.id
            //
            let shareApp = ''
            if (this.browser.ule) {
                shareApp = 'ule';
                shareObj.shareOptions = "0##1"
            } else if (this.browser.ylxd) {
                shareApp = 'ylxd'
            } else if (this.browser.ylxdsq) {
                shareApp = 'ylxdsq'
                console.log(this.source);
                
                if (this.source == 'usq') {
                    shareObj.shareOptions = "4"
                } else if(this.roomData.tvType == '9'){
                    shareObj.shareOptions = "0##1##4"
                }
            }
            (<any>window).uleStatUtil.sendEvent('broadcastShare', shareApp, location.href);
            if (this.browser.ylxd || this.browser.ylxdsq || this.browser.yzgxd) {//邮乐小店   邮乐生鲜   掌柜小店
                this.$http.jsonp("//api" + this.domain + "/ylxditem/item/getShareURL.do", { params: params, jsonp: "jsoncallback" }).then((data: any) => {
                    // let linkule = shareUrl + "?storeid=" + this.useronlyid + "&shareId=" + (data.body.data.shareId || "");
                    let linkule = data.body.data.shareUrl3;
                    shareObj.shareUrl = shareObj.shareUrl3 = linkule;
                    if (this.browser.ylxdsq && (this.source == 'usq' || this.roomData.tvType == '9')) {
                        shareObj.WXMiniProgram_OriginalId = "gh_1e6276474cf7"
                        shareObj.WXMiniProgram_path = "packageA/livePage/index?url=" + encodeURIComponent(linkule)                 
                        shareObj.WXMiniProgram_pageUrl = linkule              
                    }
                    (window as any).dsBridge.call("generalAction", {
                        type: "2",
                        ios_action: JSON.stringify(shareObj),
                        android_action: JSON.stringify(shareObj),
                    });
                });
            } else {
                (window as any).dsBridge.call("generalAction", {
                    type: "2",
                    ios_action: JSON.stringify(shareObj),
                    android_action: JSON.stringify(shareObj),
                });
            }
        });
    }
    // 倒计时结束
    close() {
        this.isShowAttentionPop = false
    }
    iGotIt() { // 关闭抽奖弹框
        this.lotteryShow = ''
    }
    clearStorage() {
        localStorage.clear();
        sessionStorage.clear();
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if (keys) {
            for (var i = keys.length; i--;) {
                document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();
                document.cookie = keys[i] + '=0;path=/;domain=' + this.domain + ';expires=' + new Date(0).toUTCString();
            }
        }
        this.$toast({
            message: "您的账号未绑定手机号，请前往“个人中心/个人资料”中进行绑定！",
            duration: 2000,
            onClose: function () {
                if (!_intercept()) {
                    return false;
                }
            }
        })
    }
    ImmediateLottery() { // 立即抽奖
        let serviceAgreementId = this.domain == '.ule.com' ? 12 : 20
        let url = `${this.api.registerYsh}?serviceAgreementId=${serviceAgreementId}`
        if (this.stagesEnvironment) url = `${this.stagesApi.registerYsh}${this.environment}`
        jsonp(url, {
            jsonp: 'jsonCallback',
            clientCallType: 'h5'
        }).then((res: any) => {
            this.show = false
            this.$toast('预约成功等待开奖')
        }).catch(res => {
            // this.$toast(res.returnMessage)
            if (res.returnCode == 76040) this.clearStorage()
        })
    }
    partakeDraw() { // 参与抽奖
        if (!_intercept()) {
            return false;
        }

        let liveName = ''
        if (this.roomData.tvStatus == 0) liveName = '待开播'
        if (this.roomData.tvStatus == 1 && this.roomData.scene_type == '2') liveName = '回放'
        if (this.roomData.tvStatus == 2) liveName = '已结束'
        // ylw_LiveRegistLottery
        _com.sendSensorTrack('直播间报名ysh抽奖', this.roomData, {
            ylw_live_id: this.roomData.id,
            ylw_live_name: this.roomData.title,
            ylw_live_type: liveName
        }, true, 'yshPoint')
        let url = `${this.api.userApply}?roomName=${this.$route.params.roomNumber}&prizeId=${this.lotteryId}`
        if (this.stagesEnvironment) {
            let participateUrl = `${this.stagesApi.getYshUserInfo}${this.environment}`
            url = `${this.stagesApi.userApply}${this.environment}?roomNum=${this.$route.params.roomNumber}&prizeId=${this.lotteryId}`
            jsonp(participateUrl, {
                jsonp: 'jsonCallback',
                clientCallType: 'h5'
            }).then((res: any) => {
                if (res.newUser == 0) {  //是否注册分期商城 0已注册 1未注册
                    jsonp(url, {
                        jsonp: 'jsonCallback',
                        clientCallType: 'h5'
                    }).then((res: any) => {
                        this.$toast('邮生活抽奖报名参与成功')
                        _com.sendSensorTrack('btnClick', this.roomData, {
                            button_name: '直播间-邮生活抽奖浮标'
                        }, true)
                    }).catch(res => {
                        if (res.returnCode == 76040) this.clearStorage()
                        this.$toast(res.returnMessage)
                    })
                } else if (res.newUser == 1) {
                    this.show = true
                } else {
                    this.$toast(res.returnMessage)
                }
            }).catch(res => {
                this.$toast(res.returnMessage)
            })

        } else {
            this.getYshUser((userId: any) => {
                jsonp(`${url}&yshUsrId=${userId}`, {
                    jsonp: 'jsonCallback',
                    clientCallType: 'h5'
                }).then((res: any) => {
                    this.$toast('邮生活抽奖报名参与成功')
                    _com.sendSensorTrack('btnClick', this.roomData, {
                        button_name: '直播间-邮生活抽奖浮标'
                    }, true)
                }).catch(res => {
                    if (res.returnCode == 76040) this.clearStorage()
                    this.$toast(res.returnMessage)
                })
            }, (res: any) => {
                this.show = true
                // if (res.returnMessage || res.msg) {
                //     this.$toast(res.returnMessage || res.msg)
                // } else {
                //     this.$toast('参与抽奖失败')
                // }
            })
        }
    }
    countDownEnd() {  // 倒计时结束
        this.countDownTime = setInterval(() => {
            if (this.yshLottery.prizes_status == 3) {
                clearInterval(this.countDownTime)
                this.finish()
            }
        }, 1000)
    }
    finish() {  // 倒计时结束查询中奖结果
        this.lotteryMouth = false
        let url = `${this.api.isuserApply}?roomName=${this.$route.params.roomNumber}&prizeId=${this.lotteryId}`
        if (this.stagesEnvironment) {
            url = `${this.stagesApi.isuserApply}${this.environment}?roomNum=${this.$route.params.roomNumber}&prizeId=${this.lotteryId}`
            jsonp(url, {
                jsonp: 'jsonCallback',
                clientCallType: 'h5'
            }).then((res: any) => {
                if (res.flag == 0) return
                let url = `${this.stagesApi.winResult}${this.environment}?roomNum=${this.$route.params.roomNumber}&prizeId=${this.lotteryId}`
                jsonp(url, {
                    jsonp: 'jsonCallback',
                    clientCallType: 'h5'
                }).then((res: any) => {
                    this.lotteryShow = res.flag
                    this.lotteryImg = res.prize_pic
                    let ua = navigator.userAgent.toLowerCase();
                    if (this.lotteryShow == 1 && ua.match(/micromessenger\/(.[^(]*)/)) {
                        this.wxConFig(true)
                    }
                })
            })
            return
        }
        this.getYshUser((userId: any) => {
            jsonp(`${url}&yshUsrId=${userId}`, {
                jsonp: 'jsonCallback',
                clientCallType: 'h5'
            }).then((res: any) => {
                if (res.flag == 0) return
                this.getYshUser((userId: any) => {
                    let url = `${this.api.winResult}?roomName=${this.$route.params.roomNumber}&prizeId=${this.lotteryId}&yshUsrId=${userId}`
                    jsonp(url, {
                        jsonp: 'jsonCallback',
                        clientCallType: 'h5'
                    }).then((res: any) => {
                        this.lotteryShow = res.flag
                        this.lotteryImg = res.prize_pic
                        let ua = navigator.userAgent.toLowerCase();
                        if (this.lotteryShow == 1 && ua.match(/micromessenger\/(.[^(]*)/)) {
                            this.wxConFig(true)
                        }
                    })
                })
            })
        })

    }
    toliveUrl(item: any, liveLink: any, index: any) {
        let clickePoints = {
            ule_title: this.roomData.title,
            resource_type: '直播间-关播推荐',
            resource_name: '直播间-关播推荐',
            resource_content: this.roomData.title,
            resource_inner_position: index + 1,
            resource_item_type: '直播',
            resource_item_id: this.roomData.scene_id,
            resource_forward_url: item.liveUrl,
            ul_aid: 'ule_live_close_recommend',
            exp_id: 'ule_live_close_rec',
            strategy_id: item.strategy
        }
        _com.sendSensorTrack('resourceExposure', this.roomData, clickePoints, true, 'yshPoint')
        location.href = `${liveLink}?parameter=true`
    }
    btnEvent(data: any) {
        let points = '关闭'
        if (data == '关闭') points = '关播推荐-关闭'
        if (data == '退出') points = '关播推荐-浏览更多直播'
        if (data == '查看更多') points = '关播推荐-退出不看了'
        let pointsData = {
            ule_title: '邮乐直播',
            button_name: points,
        }
        _com.sendSensorTrack('btnClick', this.roomData, pointsData, true)


        let burialPoint = {
            ule_title: '直播间',
            button_name: '关播推荐-关闭',
        }
        _com.sendSensorTrack('btnClick', {}, burialPoint)
    }
    getYshUser(fn: Function, err?: any) {
        let url = `${this.api.getYshUserInfo}`
        if (this.stagesEnvironment) {
            url = `${this.stagesApi.getYshUserInfo}${this.environment}`
        } else {
            if (this.userId && fn) {
                fn(this.userId)
                return
            }
        }
        jsonp(url, {
            jsonp: 'jsonCallback',
            clientCallType: 'h5'
        }).then((res: any) => {
            if (this.stagesEnvironment) {
                this.isRegisterStages = res.newUser
                return
            }
            this.userId = res.userId
            if (fn) {
                fn(res.userId)
            }
        }).catch((res) => {
            if (res.returnCode == 76040) this.clearStorage()
            if (err) {
                err(res)
            }
        })
    }
    skipPostal(data: any, jumpPage2?: any, isXcxJump?: boolean) { // 邮生活跳转
        // let url = `${this.api.getToYshInfo}?jumpPage=${data}&platform=WECHAT`
        let url = `${this.api.getToYshInfo}?jumpPage=${data}&platform=WECHAT&jumpPage2=${jumpPage2}`
        jsonp(url, {
            jsonp: 'jsonCallback',
            clientCallType: 'h5'
        }).then((res: any) => {
            if (isXcxJump) {
                this.getYhsHtml(res)
            } else if (this.$route.query.from == 'yshmp') {
                (<any>window).wx.miniProgram.navigateTo({ url: res.toYshMiniUrl })
            }
        })
    }
    toJump() {//跳转邮生活卡券中心
        if (this.browser.yshapp) {
            var data = JSON.stringify({ "pageUrl": "/myCenter/couponCenter/allCoupon_togetherTabs.html", "pageParams": null, "pageCloseStatus": false });
            (<any>window).Emp.execute("callApp('thirdH5_goToPage','goToPage','" + data + "')");
        } else if (this.$route.query.from == 'yshmp') {//邮生活小程序
            // this.skipPostal(1)
            (<any>window).wx.miniProgram.navigateTo({ url: '/pages/myCoupon/myCoupon' })//我的卡券
        }
    }
    toJumpOrder() {//跳转邮生活订单列表
        if (this.browser.yshapp) {
            var data = JSON.stringify({ "pageUrl": "/myCenter/orderCenter/myOrderListPage.html", "pageParams": { "tag": "all" }, "pageCloseStatus": false });
            (<any>window).Emp.execute("callApp('thirdH5_goToPage','goToPage','" + data + "')");
        } else if (this.$route.query.from == 'yshmp') {//邮生活小程序
            (<any>window).wx.miniProgram.navigateTo({ url: '/pages/orderPages/orderList' })//订单列表
        }
    }
    getPlaceAnOrder() { // 获取下单邮礼数据
        this.selected = 2
        this.getYshUser((userId: any) => {
            jsonp(`${this.api.couponPrizeDetail}?liveNum=${this.$route.params.roomNumber}&startTime=${new Date(this.roomData.startTime.replace(/-/g, '/')).getTime()}`, {
                jsonp: 'jsonCallback',
                clientCallType: 'h5'
            }).then((res: any) => {
                this.placeAnOrder = res
                _com.sendSensorTrack('btnClick', this.roomData, {
                    button_name: '直播间-获取邮生活查券'
                }, true)
            }).catch(res => {
                this.$toast(res.returnMessage)
            })
        }, (res: any) => {
            if (res.returnMessage || res.msg) {
                // this.$toast(res.returnMessage || res.msg)
            } else {
                this.$toast('获取邮生活查券失败')
            }
        })
    }
    takeNotes() { // 中奖记录
        // this.lotteryShow == 4
        // this.wxConFig(true)
        // return
        if (!_intercept()) {
            return false;
        }
        if (this.roomData.orderCourtesy) { // 只开了下单邮礼的抽奖
            this.getPlaceAnOrder()
        }
        if (this.isWinningRecord) {   // 有邮生活抽奖
            this.selected = 1
        }
        if (this.stagesEnvironment) {
            let url = `${this.stagesApi.winRecord}${this.environment}?roomNum=${this.$route.params.roomNumber}`
            jsonp(url, {
                jsonp: 'jsonCallback',
                clientCallType: 'h5'
            }).then((res: any) => {
                this.setWxConFig(res)
                return
            }).catch((res) => {
                if (res.returnCode == '9999' || res.returnCode == '76042') {
                    this.show = true
                } else {
                    this.$toast(res.returnMessage)
                }
                return
            })
        }
        this.getYshUser((userId: any) => {
            let url = `${this.api.winRecord}?roomName=${this.$route.params.roomNumber}&yshUsrId=${userId}`
            jsonp(url, {
                jsonp: 'jsonCallback',
                clientCallType: 'h5'
            }).then((res: any) => {
                _com.sendSensorTrack('btnClick', this.roomData, {
                    button_name: '直播间-邮生活抽奖中奖记录'
                }, true)
                this.setWxConFig(res)
            })
        }, (res: any) => {
            if (res.returnCode == '9999') {
                this.show = true
            }
        })
    }
    setWxConFig(res: any) {
        let isLottery;
        try {
            isLottery = (res || []).findIndex((item: any) => { return item.flag == 1 })
        } catch (error) {
            isLottery = -1
        }
        this.lotteryShow = 4
        this.lotteryList = res
        let ua = navigator.userAgent.toLowerCase();
        if (this.lotteryShow == 4 && ua.match(/micromessenger\/(.[^(]*)/)) {
            this.wxConFig(true)
        }
    }
    recruitPersonnel() {
        if (!_intercept()) {
            return false;
        }
        location.href = `https://h5${this.domain}/hd/liveBroadcast/application/lication.html?roomNumber=${this.roomData.roomNumber}&roomId=${this.roomData.id}&sceneId=${this.roomData.scene_id}`;
    }
    // 获取关注状态
    getAttentionStatus() {
        const callback = 'getfollow'
        let url = `${this.api.getAttentionStatus}?room_id=${this.roomId}`
        jsonp(url, {
            jsonp: 'callback',
            jsonpcallback: callback
        }).then((res: any) => {
            this.attentionStatus = + res.flag
            // 设置自动推送，则未关注房间的用户在观看直播15s后显示弹框
            if (this.attentionStatus === 0) {
                // if (this.attentionStatus === 0 && this.roomData.auto_follow) {
                this.timer = setTimeout(() => {
                    this.showAttention()
                }, 15000)
            }
        }).catch(res => {
            this.timer = setTimeout(() => {
                this.showAttention()
            }, 15000)
        })
    }

    // 关注或取消关注 flag 0 - 取消关注 1 - 关注
    attention(status: number, type: any) {
        if (!_intercept(type)) {
            return false;
        }

        let liveName = ''
        if (this.roomData.tvStatus == 0) liveName = '待开播'
        if (this.roomData.tvStatus == 1 && this.roomData.scene_type == '2') liveName = '回放'
        if (this.roomData.tvStatus == 2) liveName = '已结束'

        let ylw_Focus = {
            // ylw_live_id: this.roomData.id,
            // ylw_live_name: this.roomData.title,
            // ylw_live_type: liveName,
            ylw_enter_source: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
            ylw_live_id: this.roomData.id,
            ylw_live_name: this.roomData.title,
            ylw_live_type: liveName,
            roomNumber: this.roomData.roomNumber,
            scene_number: this.roomData.scene_number,
            theme: this.roomData.theme,
            ylw_adid: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid')
        }
        _com.sendSensorTrack('Focus', this.roomData, ylw_Focus, false, 'yshPoint')


        let burialPoint = {
            ule_title: '直播间',
            button_name: '直播间关注弹窗-立即关注',
            // remarks: this.$route.params.roomNumber,
            scene_number: this.roomData.scene_number,
            roomNumber: this.$route.params.roomNumber
        }

        _com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')

        clearTimeout(this.timer)
        let callback = "changeUserFollow";
        jsonp(
            `${this.api.attention}?room_id=${this.roomId}&flag=${status}&originType=${this.roomData.tvType}&callback=${callback}`,
            {
                jsonpcallback: callback,
                jsonp: 'callback',
            }
        ).then((res: any) => {
            let flag = +res.flag
            let msg = flag === 0 ? '已取消关注' : '关注成功'
            this.$toast(msg)
            this.attentionStatus = flag
        }).catch((res: any) => {
            this.$toast(res.msg)
        })
        // 关注埋点
        _com.sendSensorTrack((status == 1 ? 'Focus' : 'FocusCancel'), this.roomData, ylw_Focus, false, 'yshPoint')
        // _com.sendSensorTrack((status == 1 ? 'Focus' : 'FocusCancel'), ylw_Focus, {})
    }
    // 浮标设置
    floation() {
        this.$http.jsonp(this.api.floation, {
            jsonp: "jsonCallBack",
            jsonpCallback: "getFloation"
        }).then((data: any) => {
            this.floationData = data.data.ule_broadcast_floaticon[0] || {};
            if (this.floationData.customAttribute) {
                if (typeof this.floationData.customAttribute == 'string') {
                    this.floationData.customAttribute = JSON.parse(this.floationData.customAttribute)
                }
                if (this.floationData.customAttribute.xcxName) {
                    let ua = navigator.userAgent.toLowerCase();
                    if (this.floationData.customAttribute.xcxName == 'ysh') {
                        let client = sessionStorage.getItem('xcx.type') || _cookie.get('ul_sch') || _cookie.get('client_type') || ''
                        //fromChannel ：来源渠道，ule：邮乐，ulexd：邮乐小店
                        //platform ：WECHAT 微信 H5 平台、MP 微信小程序、APP APP
                        //code：第几个入口                            
                        let fromChannel = 'ule', platform = 'WECHAT';
                        if (client) {
                            client = client.split('_').pop()
                            if (client == 'ylxd' || this.browser.ylxd) {
                                fromChannel = 'ulexd'
                            } else {
                                fromChannel = 'ule'
                            }
                        }
                        if (this.browser.ylxd || this.browser.ule) {//小店app  邮乐APP
                            platform = 'APP'
                        } else if (/miniprogram/.test(ua)) {//小程序
                            platform = 'MP'
                        } else {//微信
                            platform = 'WECHAT'
                        }
                        if (this.floationData.customAttribute.xcxLink.indexOf('?') > 0) {
                            this.floationData.customAttribute.xcxLink += `&fromChannel=${fromChannel}&platform=${platform}&code=1`
                        } else {
                            this.floationData.customAttribute.xcxLink += `?fromChannel=${fromChannel}&platform=${platform}&code=1`
                        }
                    }
                    if (ua.match(/micromessenger\/(.[^(]*)/)) {//微信内  包含小程序
                        this.wxConFig(false)
                    }

                }
            }
        })
        // (<any>window).getFloation = (data: any) => {
        //     try {
        //     } catch (error) {

        //     }
        // // }, 
        // () => { })
    }
    wxConFig(isYsh: boolean) {
        let roomNumber: any = this.$route.params.roomNumber;
        let appId = (this.domain.indexOf('beta') >= 0) ? 'wx8b73da0067c52318' : 'wx174a5809f2b70161';//必须是服务号id！！！
        //  wx8b73da0067c52318 (beta) wxc0bdbc30eff80e50(testing  邮乐购公众号)  wx174a5809f2b70161(生产邮乐VIP公众号)
        let href = (location.hostname == 'localhost') ? ('https://h5' + this.domain + location.pathname) : location.href;
        let url = `https://service${this.domain}/api/mobile/getWechatSignature.do`
        let signature: any = sessionStorage.getItem("signature")
        if (signature) {
            signature = JSON.parse(signature)
            if (signature[roomNumber] && signature[roomNumber].href == location.href) {
                this.config(appId, signature[roomNumber].data, isYsh)
                return
            }
        } else {
            signature = {}
        }
        jsonp(url, {
            jsonp: 'jsonApiCallback',
            lotteryInfoId: 325,
            currentPageUrl: href,
            appkey: '4b9f40822ddd5cd5',
            version_no: 'apr_2010_build01',
            appId: appId,
            t: Math.random()
        }).then((data: any) => {
            // alert(JSON.stringify(data))
            console.log('dfs');
            this.config(appId, data.detail[0], isYsh)
            signature[roomNumber] = {
                data: data.detail[0],
                href: location.href
            }
            sessionStorage.setItem("signature", JSON.stringify(signature));
        }).catch((err: any) => {
            // alert(JSON.stringify(err))
            // alert(JSON.stringify(err))
        });
    }
    config(appId: any, data: any, isYsh: boolean) {
        (<any>window).wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
            appId: appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: ['onMenuShareAppMessage', 'error', 'openLocation'],
            // jsApiList: ['onMenuShareAppMessage', 'error', 'openLocation'], // 必填，按需写
            openTagList: ['wx-open-launch-weapp'], // 可选，需使用开放标签，如['wx-open-launch-app']
        })
        if (isYsh) {
            this.skipPostal(1, 3, true);
            (<any>window).wx.ready(function () {

            })
        } else {
            this.getHtml()
        }
    }
    getYhsHtml(res: any) {
        // if (navigator.userAgent.indexOf('miniProgram') > -1 && (!this.browser.yshapp || this.$route.query.from != 'yshmp')) return
        let script = document.createElement('script')
        script.type = 'text/wxtag-template'
        script.text = `<span style="display:block;height: 30px;line-height:30px;color:#fff;text-align:center;width: 100%;">立即兑换></span>`
        let script1 = document.createElement('script')
        script1.type = 'text/wxtag-template'
        script1.text = `<span style="display:block;height: 30px;line-height:30px;color:#fff;text-align:center;width: 100%;">查看订单></span>`
        this.toYsh =
            `<wx-open-launch-weapp id="immediately"
                                username="${res.yshOrgId}"
                                path="${res.toYshMiniUrl}"
                                >${script.outerHTML}
                            </wx-open-launch-weapp>`
        if (res.toYshMiniUrl2) {
            this.toYshDD =
                `<wx-open-launch-weapp id="order"
                                    username="${res.yshOrgId}"
                                    path="${res.toYshMiniUrl2}"
                                    >${script1.outerHTML}
                                </wx-open-launch-weapp>`
        }
    }
    //是否显示浮标
    isShowFloation() {
        if (this.floationData.imgUrl) {
            //showRoom 设置为none  所有房间不显示浮标
            if (this.floationData.customAttribute.showRoom == 'none') {
                return false
            } else if (this.floationData.customAttribute.showRoom == '') {//showRoom 未设置
                // hideRoom 设置该房间号  不显示浮标
                if (this.floationData.customAttribute.hideRoom.indexOf(this.roomData.roomNumber) > -1) {
                    return false
                } else {
                    return true
                }
            } else {
                // showRoom 设置了改房间   并且hideRoom未设置该房间   显示浮标
                if (this.floationData.customAttribute.showRoom.indexOf(this.roomData.roomNumber) > -1 && this.floationData.customAttribute.hideRoom.indexOf(this.roomData.roomNumber) == -1) {
                    return true
                } else {
                    return false
                }
            }
        } else {
            return false
        }
    }
    getHtml() {
        let script = document.createElement('script')
        script.type = 'text/wxtag-template'
        script.text = `<img src="${this.floationData.imgUrl}" style="height: 40px;width: 40px;" alt=""
        data-stat="点击浮标跳转小程序页面link=${this.floationData.customAttribute.xcxLink}&xcxName=${this.floationData.customAttribute.xcxName}">`
        this.wxHtml =
            `<wx-open-launch-weapp id="launch-btn"
                                username="${this.floationData.customAttribute.id}"
                                path="${this.floationData.customAttribute.xcxLink}"
                                >${script.outerHTML}
                            </wx-open-launch-weapp>`
        this.$nextTick(() => {
            let launchButton: any = document.getElementById('launch-btn')
            launchButton.addEventListener('launch', function (e: any) {
                console.log('success', e)
            })

            launchButton.addEventListener('error', function (e: any) {
                console.log('fail', e)
            })
        })
    }
    goLink(data: any) {
        if (this.browser.ylxd && data.customAttribute.id && (<any>window).dsBridge) {
            (<any>window).dsBridge.call("uleNativePay", {//打开小程序方法   
                payModelCode: 'SDKWXMiniProgramPay',
                userName: data.customAttribute.id,
                pageUrl: data.customAttribute.xcxLink
            }, function () {

            })
        } else if (data.link) {
            data.link = data.link + (data.link.indexOf('?') > 0 ? '&' : '?') + 'sourcefrom=broadlive';
            if (this.$route.query.storeid && this.$route.query.shareId) {
                data.link = data.link + '&storeid=' + this.$route.query.storeid + '&shareId=' + this.$route.query.shareId + '&appName=ylxd';
            }
            location.href = data.link
        }
    }

    getLivePeopleCount(time?: string) { //房间观众数
        setTimeout(() => {
            let callback = "people";
            let url = `${this.api.getPeopleCountApi}${this.$route.params.roomNumber}/${callback}?t=${new Date().getTime()}`;
            this.$store
                .dispatch("timing/getPeopleAsync", {
                    url: url,
                    callback: callback,
                })
                .then((data: any) => {
                    if (this.$route.params.roomNumber) {
                        this.getLivePeopleCount(data.refreshTime);
                    }
                });
        }, parseInt(time || '0'))
    }
    talkLater() {
        this.isNewPeople = false
        _com.sendSensorTrack('btnClick', this.roomData, {
            button_name: '直播间-新人福利-以后再说'
        }, true)
        this.closeOperation()
    }
    goToSee() {
        this.isNewPeople = false
        _com.sendSensorTrack('btnClick', this.roomData, {
            button_name: '直播间-新人福利-去看看'
        }, true)
        location.href = this.exitJumpLink
        // location.href = 'https://www.ule.com/event/h5/ule/5093.html?adid=ylwxr_zbhz'
    }
    checkboxLook(data: any) {
        localStorage.setItem('lookLive', this.look)
    }
    moreLive() {
        let burialPoint = {
            ule_title: '直播间',
            // button_name: '关播推荐-' + this.drainageTitle,
            button_name: '关播推荐-浏览更多直播',
        }
        _com.sendSensorTrack('btnClick', {}, burialPoint)

        this.btnEvent('查看更多')
        // location.href = `https://h5${process.env.VUE_APP_URI_DOMAIN}/hd/debutBroadcastList/index.html`
        if (this.drainageTolink) {
            location.href = this.drainageTolink
        } else {
            location.href = `https://h5${process.env.VUE_APP_URI_DOMAIN}/hd/debutBroadcastList/index.html`
        }
    }
    async lookClik() {
        let style: any = document.querySelectorAll('.allIcons')[0]
        style.style.display = 'none'
        let fnBooen = false
        await this.$http
            .jsonp(`${this.api.liveExitRecommend}?roomNum=${this.$route.params.roomNumber}&jsonCallBack=live_exit_recommend`, {
                jsonp: "jsonpCallback",
                jsonpCallback: "live_exit_recommend",
            }).then((data: any) => {
                if (data.body.code == '0000') {
                    if (data.body.data.liveRoomInfo.length > 0) {
                        let pointsData = {}
                        data.body.data.liveRoomInfo.forEach((item: any, index: any) => {
                            pointsData = {
                                ule_title: this.roomData.title,
                                button_name: 'resourceExposure',
                                resource_type: '直播间-关播推荐',
                                resource_name: '直播间-关播推荐',
                                resource_content: this.roomData.title,
                                resource_inner_position: index + 1,
                                resource_item_type: '直播',
                                resource_item_id: this.roomData.scene_id,
                                resource_forward_url: item.liveUrl,
                                ul_aid: 'ule_live_close_recommend',
                                exp_id: 'ule_live_close_rec',
                                strategy_id: item.strategy
                            }
                            _com.sendSensorTrack('resourceExposure', this.roomData, pointsData, true, 'yshPoint')
                        });
                    }
                    this.selectedLive = data.body.data.liveRoomInfo
                    fnBooen = true
                } else {
                    fnBooen = false
                }
            })
        return fnBooen
    }
    async exit() { //关闭按钮 返回上一页
        if (this.browser.usqxcx && this.roomData.tvType == 3) {
            (<any>window).wx.miniProgram.switchTab({ url: `/pages/index/index` })//购物车列表
            return
        }
        let isShowBottomLiveLog = ''
        await this.lookClik().then((res: any) => {
            isShowBottomLiveLog = res
        })
        _com.sendSensorTrack('btnClick', this.roomData, {
            button_name: '直播间-关闭直播'
        }, true)
        let new_user_remain: any = sessionStorage.getItem('new_user_remain') // 0不留存  1留存
        let dateOff: any = sessionStorage.getItem('dateOff')
        let storageTime: any = localStorage.getItem(`storageTime-${this.roomData.id}-${this.roomData.roomNumber}`) // 缓存时间   
        let date = new Date()
        let sameDay = false
        if (!Boolean(storageTime) || Boolean(dateOff)) {
            localStorage.setItem(`storageTime-${this.roomData.id}-${this.roomData.roomNumber}`, `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${this.roomData.id}-${this.roomData.roomNumber}`)
        } else {
            let timeSplit = storageTime.split('-')
            if (timeSplit[0] == date.getFullYear() && date.getMonth() + 1 == timeSplit[1] && timeSplit[2] == date.getDate() && timeSplit[3] == this.roomData.id && timeSplit[4] == this.roomData.roomNumber) {
                sameDay = true
            }
        }
        if (new_user_remain == 0) {
            if ((localStorage.getItem('lookLive') == 'true') || this.roomData.userSource == 2) {
                this.closeOperation()
            } else {
                sameDay ? this.closeOperation() : isShowBottomLiveLog ? this.isShowBottomLive = true : this.closeOperation()
            }
            return
        }

        let callback = "json25"
        let url = `https://m${process.env.VUE_APP_URI_DOMAIN}/mobileact/live/isNewCus?callback=json25`
        jsonp(url, {
            jsonp: 'jsonCallback',
            jsonpcallback: callback
        }).then(
            (data: any) => {  // 0 老用户   // 1新用户
                let newUser = data.isNewCus
                // newUser == 1 ? this.exitJump() : this.isShowOtherLive = true
                newUser == 1 ? this.exitJump() : sameDay ? this.closeOperation() : isShowBottomLiveLog ? this.isShowBottomLive = true : this.closeOperation()
            }
        ).catch((err: any) => {
            this.exitJump()
        })
    }
    closeOperation(data?: any) {
        // this.pDpm += '1'
        if (data == '退出') this.btnEvent('退出')
        let burialPoint = {
            ule_title: '直播间',
            button_name: '关播推荐-退出不看了',
        }
        _com.sendSensorTrack('btnClick', {}, burialPoint)

        if (this.$route.query.sourcefrom == 'ulemp') {//邮乐商城小程序入参  返回商城小程序首页
            (<any>window).wx.miniProgram.switchTab({ url: '/pages/index' })
            // this.pDpm += '2'
        } else if (!document.referrer || location.search.includes('parameter=true')) {
            // this.pDpm += '3'
            if (this.browser.ule || this.browser.ylxd || this.browser.ylxdsq || this.browser.yzg || this.browser.yzgxd || this.browser.yzs) {
                // APP里，退出页面
                // this.pDpm += '4'
                location.href = 'ULEMOBILE://ulePopView';
            } else if (this.browser.ulexcx) {
                // 邮乐商城小程序里
                (<any>window).wx.miniProgram.navigateBack({})
                // this.pDpm += '5'
            } else if (this.browser.uxdxcx) {
                // 邮乐小店小程序里
                (<any>window).wx.miniProgram.navigateBack({})
                // this.pDpm += '6'
            } else if (this.browser.usqxcx || this.source == 'usq') {
                // 邮乐优鲜小程序 或 优鲜H5，返回到优鲜首页
                // this.pDpm += '7'
                location.href = '//h5' + this.domain + '/yxd/community/'
            } else if (this.source == 'uzg') {
                // this.pDpm += '8'
                location.href = '//www' + this.domain + '/app/yzg/wholesale_h5/index.html'
            } else if (this.$route.query.storeid && this.$route.query.shareId) {
                // 返回到小店店主店铺页
                // this.pDpm += '9'
                location.href = '//m' + this.domain + '/mxiaodian/store/home.html?storeid=' + this.$route.query.storeid
            } else {
                // 默认返回到M站首页
                location.href = '//m' + this.domain + '/'
            }
        } else {
            // this.pDpm += 'C'
            sessionStorage.setItem("back", "true");
            (<any>window).history.back();
        }
    }
    more() {
        this.$store.dispatch('environment/getIsShowOperatAsync', true);
    }
}
